import { ChevronUpIcon, ChevronDownIcon } from '@heroicons/react/24/outline';
import { ReactNode, useState } from 'react';

interface CollapsibleSectionProps {
  title: string;
  icon?: ReactNode;
  children: ReactNode;
  initialExpanded?: boolean;
  titleClassName?: string;
  contentClassName?: string;
  headerClassName?: string;
}

const CollapsibleSection = ({
  title,
  icon,
  children,
  initialExpanded = false,
  titleClassName = 'text-base font-bold text-black',
  contentClassName = 'mt-4 space-y-6 border-t pt-4',
  headerClassName = 'flex w-full items-center justify-between',
}: CollapsibleSectionProps) => {
  const [isExpanded, setIsExpanded] = useState(initialExpanded);

  return (
    <div className="border-t pt-4">
      <button
        className={headerClassName}
        onClick={() => setIsExpanded(!isExpanded)}
      >
        <div className="flex items-center">
          {icon && <div className="mr-2">{icon}</div>}
          <p className={titleClassName}>{title}</p>
        </div>
        {isExpanded ? (
          <ChevronUpIcon className="size-5 text-gray-500" />
        ) : (
          <ChevronDownIcon className="size-5 text-gray-500" />
        )}
      </button>

      {isExpanded && <div className={contentClassName}>{children}</div>}
    </div>
  );
};

export default CollapsibleSection;
